import React from 'react';
import cn from 'classnames';

var styles = {"spinner":"spinner__spinner_z6ra6","spin_animation":"spinner__spin_animation_z6ra6","visible":"spinner__visible_z6ra6","s":"spinner__s_z6ra6","m":"spinner__m_z6ra6"};
require('./index.css');

var Spinner = function (_a) {
    var _b;
    var _c = _a.size, size = _c === void 0 ? 's' : _c, visible = _a.visible, id = _a.id, className = _a.className, dataTestId = _a.dataTestId;
    return (React.createElement("span", { className: cn(className, styles.spinner, styles[size], (_b = {},
            _b[styles.visible] = visible,
            _b)), id: id, "data-test-id": dataTestId }));
};

export { Spinner };
